import { render } from "./AddressSearch.vue?vue&type=template&id=32a45a7b&scoped=true"
import script from "./AddressSearch.vue?vue&type=script&lang=js"
export * from "./AddressSearch.vue?vue&type=script&lang=js"

import "./AddressSearch.vue?vue&type=style&index=0&id=32a45a7b&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/lauryncoleman/lauryncoleman/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a45a7b"]])

export default __exports__